import { ConsumerType, getEnvConfig } from '@/constants';

/**
 * Builds the authorization headers for API requests.
 *
 * When the consumer type is Cvent and a Cvent environment is configured, returns
 * Cvent-specific headers (`X-Cvent-Authorization` and `X-Cvent-Environment`);
 * otherwise falls back to a standard `Authorization` bearer header.
 *
 * @param token - Optional access token. Defaults to `window.accessToken` when omitted.
 * @returns A headers object suitable for spreading into a request's headers.
 */
export const buildAuthRequestHeaders = (token?: string): Record<string, string> => {
  const accessToken = token || window.accessToken;

  const useCventAuth = getEnvConfig('CONSUMER_TYPE') === ConsumerType.Cvent;
  if (useCventAuth) {
    const cventEnvironment = getEnvConfig('CVENT_ENVIRONMENT');
    if (accessToken && cventEnvironment) {
      return {
        'X-Cvent-Authorization': `Bearer ${accessToken}`,
        'X-Cvent-Environment': cventEnvironment
      };
    }
  }

  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};
